module.exports = __webpack_public_path__ + "media/images/bg_customer_mv_sp-dee13cbde445c8feadeca6adb849ff04.jpg";